export const appointmentStatusHash = {
  scheduled: 'bg-green-100 text-green-700 border-green-200',
  deferred: 'bg-yellow-100 text-yellow-700 border-yellow-200',
  declined: 'bg-red-100 text-red-700 border-red-200',
  not_needed: 'bg-blue-100 text-blue-700 border-blue-200',
  completed: 'bg-green-100 text-green-700 border-green-200',
}
